import React from 'react';
import { StyledComponentProps, withStyles } from '@material-ui/core';
import { IconButton as MuiButton } from '@material-ui/core';
import { styles } from './styles';
import { ReactComponent as RightArrow } from '../../images/icons/arrow-right.svg';

interface IProps extends StyledComponentProps {
    onClick: () => any;
    disabled?: boolean;
}

const NextButton = (props: IProps) => {
    return (<MuiButton
        disabled={props.disabled}
        className={props.classes.iconButtonRootSvgSecondary}
        onClick={props.onClick}>
         <RightArrow className={props.classes.iconButtonSvgSecondary}/>
    </MuiButton>)
}
export default withStyles(styles)(NextButton)